module.exports = __webpack_public_path__ + "static/media/orange_icon.42bb5591.svg";